module.exports = __webpack_public_path__ + "media/images/front/services/transport-669c2a971584f14b2fe7a8e638cf43a8.webp";